function FormatTimeDayMonthYearAMPM(date, type = '') {
  let d;
  if (date) {
    d = new Date(date);
  } else {
    d = new Date();
  }
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
  let hours = d.getHours();
  let minutes = d.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  let finaldate = '';
  if (type === 'slash') {
    const month = String(d.getMonth() + 1).length > 1 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
    finaldate = `${da}/${month}/${ye}; ${strTime}`;
  }
  if (type === 'slashwithoutTime') {
    const month = String(d.getMonth() + 1).length > 1 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
    finaldate = `${da}/${month}/${ye}`;
  } else {
    finaldate = `${da}-${mo}-${ye}, ${strTime}`;
  }
  return finaldate;
}

function parseCustomDate(dateStr) {
  const [datePart, timePart, meridian] = dateStr.split(' ');
  const [dd, mm, yyyy] = datePart.split('-');
  let [hh, min] = timePart.split(':');
  hh = parseInt(hh, 10);
  min = parseInt(min, 10);
  if (meridian === 'PM' && hh < 12) {
    hh += 12;
  } else if (meridian === 'AM' && hh === 12) {
    hh = 0;
  }
  // Format to ISO string: yyyy-mm-ddThh:mm:ss
  const isoString = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}T${hh.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:00`;
  return new Date(isoString);
}

export { FormatTimeDayMonthYearAMPM, parseCustomDate };
